module.exports = __webpack_public_path__ + "static/media/hollowknight.d732b8a7.png";